import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";

/* jshint esnext: true */
import React from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';
import Button from '../molecules/Button';
import Label from '../molecules/Label';
import Icon from '../molecules/Icon';

var InputBox = function InputBox(props) {
  var icon = props.icon,
      button = props.button,
      buttonProps = props.buttonProps,
      className = props.className,
      children = props.children,
      messageType = props.messageType,
      leftLabel = props.leftLabel,
      leftLabelProps = props.leftLabelProps,
      rightLabel = props.rightLabel,
      rightLabelProps = props.rightLabelProps,
      style = props.style,
      transparent = props.transparent,
      inputStyle = props.inputStyle,
      others = _objectWithoutProperties(props, ["icon", "button", "buttonProps", "className", "children", "messageType", "leftLabel", "leftLabelProps", "rightLabel", "rightLabelProps", "style", "transparent", "inputStyle"]);

  var classes = mixClass(className, messageType, 'input', {
    labeled: leftLabel || rightLabel,
    right: rightLabel,
    action: button && !icon,
    icon: icon,
    transparent: transparent
  });
  var thisLeftLabel;

  if (leftLabel) {
    thisLeftLabel = /*#__PURE__*/React.createElement(Label, leftLabelProps, leftLabel);
  }

  var thisRightLabel;

  if (rightLabel) {
    thisRightLabel = /*#__PURE__*/React.createElement(Label, _extends({
      style: Styles.rightLabel,
      className: "basic"
    }, rightLabelProps), rightLabel);
  }

  var thisButton = null;

  if (button) {
    thisButton = /*#__PURE__*/React.createElement(Button, buttonProps, button);
  }

  if (icon) {
    thisButton = /*#__PURE__*/React.createElement(Icon, {
      style: Styles.icon
    }, icon);
  }

  return /*#__PURE__*/React.createElement(SemanticUI, {
    className: classes,
    style: style
  }, thisLeftLabel, /*#__PURE__*/React.createElement(SemanticUI, _extends({
    atom: "input"
  }, others, {
    style: inputStyle,
    ui: false
  })), thisRightLabel, children, thisButton);
};

InputBox.defaultProps = {
  button: 'Submit'
};
export default InputBox;
var Styles = {
  rightLabel: {
    borderRadius: 0
  },
  icon: {
    width: '1.1em',
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: .5
  }
};